var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[_c('div',{staticClass:"text-dark fw-bolder text-hover-primary mb-1 fs-6"},[_vm._v("\n      "+_vm._s(this.status)+"\n    ")])]),_c('td',{staticClass:"text-end"},[_vm._v("\n    "+_vm._s(this.date)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }